import { render, staticRenderFns } from "./EstablishmentRoleInfo.vue?vue&type=template&id=e6972722&scoped=true&"
import script from "./EstablishmentRoleInfo.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6972722",
  null
  
)

export default component.exports